import { render, staticRenderFns } from "./simulador-pesquisa-historico.vue?vue&type=template&id=2630244c&"
import script from "./simulador-pesquisa-historico.vue?vue&type=script&lang=js&"
export * from "./simulador-pesquisa-historico.vue?vue&type=script&lang=js&"
import style0 from "./simulador-pesquisa-historico.vue?vue&type=style&index=0&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2630244c')) {
      api.createRecord('2630244c', component.options)
    } else {
      api.reload('2630244c', component.options)
    }
    module.hot.accept("./simulador-pesquisa-historico.vue?vue&type=template&id=2630244c&", function () {
      api.rerender('2630244c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/simulador-pesquisa-historico.vue"
export default component.exports